import fuzzy from 'fuzzy';

const getSchoolFilter = response => {
  const formattedData = response.data.map(entry => ({
    id: entry.pk,
    name: entry.name,
  }));

  const searchable = formattedData.length > 10;
  return {
    key: 'schools',
    source: 'schools',
    filterName: 'Schools',
    searchable,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
    search: searchTerm => {
      const results = searchTerm
        ? formattedData.filter(({ name }) => fuzzy.match(searchTerm, name))
        : formattedData;
      return results;
    },
    infiniteScroll: searchable,
    searchOnOpen: searchable,
  };
};

export default getSchoolFilter;
